import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { DialogActions, Grid, TextField } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { updateCategory } from 'lib/api/tags';
import { useDispatch } from 'react-redux';
import { showAlert } from 'lib/functions/utils';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';

const AddCategory = (props: any) => {
  const { open, onClose, setUp, category } = props;
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(category.name);
  const [description, setDescription] = useState(category.description);
  const dispatch = useDispatch();

  const handleEditCategory = async () => {
    if (!name || !description) {
      showAlert(dispatch, 'error', 'Todos los campos son requeridos');
      return;
    };
    setLoading(true);
    try {
      await updateCategory(dispatch, {
        name,
        description,
      }, category.id);
      showAlert(dispatch, 'success', 'Categoría editada correctamente');
      setUp(category.id);
      onClose();
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al editar la categoría');
    }
    setLoading(false);
  };

  return (
    <div>
      <Dialog open={open} maxWidth="sm" >
        <DialogTitle>Editar Categoría</DialogTitle>
        <DialogContent>
          {loading && (
            <div style={{ minHeight: 100 }}>
              <CenteredCircularProgress type="dialog" />
            </div>
          )}
          {!loading && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography fontWeight={600}>Nombre:</Typography>
                </Grid>
                <Grid item xs={6} style={{ display: 'flex', alignItems: 'center' }}>
                  <TextField
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Nombre"
                    style={{ width: '100%' }}
                  />
                </Grid>
                <Grid item xs={6} style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography fontWeight={600}>Descripción:</Typography>
                </Grid>
                <Grid item xs={6} style={{ display: 'flex', alignItems: 'center' }}>
                  <TextField
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Descripción"
                    multiline
                    style={{ width: '100%' }}
                  />
                </Grid>
              </Grid>
            </div>
          )
          }
        </DialogContent >
        <DialogActions>
          <CustomButton
            onClick={onClose}
            color="secondary"
            disabled={loading}
          >
            Salir
          </CustomButton>
          <CustomButton
            onClick={handleEditCategory}
            color="success"
            disabled={loading}
          >
            Guardar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddCategory;